// src/utils/permissionTranslator.ts
import { TFunction } from 'i18next';

export function translatePermission(permission: string, t: TFunction): string {
    const translation = t(`permissions.${permission}`);
    if (translation.startsWith('permissions.')) {
        return permission;
    }
    return translation;
}
